import clsx from 'clsx';
import React from 'react';

import imgRectangleLeft from 'images/pro/rectangle-left.svg';
import imgRectangleRight from 'images/pro/rectangle-right.svg';

import useCurrentUser from '../../hooks/useCurrentUser';
import { subscribe_promotion_path, upgrade_subscription_path } from '../../routes';
import {
  DEFAULT_ANNUAL_OFFER_CODE,
  DEFAULT_MONTHLY_OFFER_CODE,
  DEFAULT_PRO_OFFER_CODE,
  DEFAULT_YP_OFFER_CODE,
} from '../../src/constants';

const ProFooterCallout = () => {
  const { currentUser } = useCurrentUser();
  const isCurrentUserSubscriber = currentUser?.is_subscriber;
  const isCurrentUserProSubscriber = currentUser?.is_pro_subscriber;

  return (
    <div className="bg-secondary-pink px-16 xs:px-48 py-40 text-center relative">
      <div className="relative z-[1]">
        <p className="font-sans text-overline text-primary-red uppercase m-0">
          {isCurrentUserSubscriber && !isCurrentUserProSubscriber
            ? 'Upgrade now'
            : !isCurrentUserSubscriber && 'Subscribe'}
        </p>
        <p className="font-serif text-headline-sm md:text-headline-lg text-primary-black m-0 mt-8 md:mt-16">
          The Information Pro.
          <br />
          Don{'’'}t take a meeting without it.
        </p>
        {!isCurrentUserProSubscriber && (
          <a
            href={
              isCurrentUserSubscriber
                ? upgrade_subscription_path()
                : subscribe_promotion_path({
                    offer: `${DEFAULT_PRO_OFFER_CODE},${DEFAULT_ANNUAL_OFFER_CODE},${DEFAULT_MONTHLY_OFFER_CODE},${DEFAULT_YP_OFFER_CODE}`,
                  })
            }
            className={clsx(
              'text-button-md font-sans !text-white bg-primary-red uppercase',
              'xs:w-[245px] h-40 flex items-center justify-center rounded-r-2 mx-auto mt-16 md:mt-32',
              'hover:bg-pro-red focus:bg-pro-red transition-colors'
            )}
          >
            {isCurrentUserSubscriber ? 'Go Pro' : 'Get Started'}
          </a>
        )}
      </div>
      <div className="absolute -top-px left-0 w-[133px] xs:w-[200px] sm:w-[300px] md:w-[416px]">
        <img className="block object-contain object-top w-full" src={imgRectangleLeft} alt="" />
      </div>
      <div className="absolute -bottom-px right-0 w-[133px] xs:w-[200px] sm:w-[300px] md:w-[416px]">
        <img className="block object-contain object-top w-full" src={imgRectangleRight} alt="" />
      </div>
    </div>
  );
};

export default ProFooterCallout;
